<template>
  <div class="card tm-filters-card mb-4" :class="{ 'has-filters': hasActiveFilters }">
    <div 
      class="card-header border-0 bg-transparent pt-4 pb-2 px-4 cursor-pointer"
      @click="isCollapsed = !isCollapsed"
    >
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <div class="icon-box me-3" :class="{ 'bg-primary-soft': !isCollapsed, 'bg-secondary-soft': isCollapsed }">
            <i class="fas fa-filter" :class="isCollapsed ? 'text-secondary' : 'text-primary'"></i>
          </div>
          <div>
            <h6 class="mb-0 fw-bold text-dark opacity-75 text-uppercase letter-spacing-1">
              Filtros de Atividades
            </h6>
            <span v-if="hasActiveFilters" class="text-primary fw-bold small">
              {{ activeFiltersCount }} filtro(s) ativo(s)
            </span>
            <span v-else class="text-muted small">Clique para configurar filtros</span>
          </div>
        </div>
        <div class="collapse-icon">
          <i class="fas" :class="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
        </div>
      </div>
    </div>

    <div v-show="!isCollapsed" class="card-body px-4 py-4">
      <div class="row g-3 align-items-end">
        <div class="col-md-2">
          <label class="filter-label">Início</label>
          <date-picker v-model="filters.startDate" format="DD/MM/YYYY" value-type="format" placeholder="Início" />
        </div>
        <div class="col-md-2">
          <label class="filter-label">Fim</label>
          <date-picker v-model="filters.endDate" format="DD/MM/YYYY" value-type="format" placeholder="Fim" />
        </div>

        <div class="col-md-2">
          <label class="filter-label">Atividade</label>
          <v-select 
            :reduce="t => t.id" 
            placeholder="Todas..." 
            label="name"
            v-model="filters.task" 
            :options="tasks"
            append-to-body
          />
        </div>

        <div class="col-md-2">
          <label class="filter-label">Classificação</label>
          <v-select 
            :reduce="t => t.id" 
            placeholder="Todas..." 
            label="name"
            v-model="filters.taskType" 
            :options="taskTypes"
            append-to-body
          />
        </div>

        <div class="col-md-2">
          <label class="filter-label">Cliente</label>
          <v-select 
            :reduce="c => c.id" 
            placeholder="Todos..." 
            label="name"
            v-model="filters.customer" 
            :options="customers"
            append-to-body
          />
        </div>

        <div class="col-md-2 d-flex gap-2 justify-content-end align-self-end">
          <button class="btn btn-sm btn-warning" @click="emit" title="Filtrar">
            <i class="fa fa-search"></i>
          </button>
          <button class="btn btn-sm btn-danger" @click="clear" title="Limpar Filtros">
            <i class="fa fa-trash"></i>
          </button>
        </div>

        <div class="col-md-10">
          <label class="filter-label">Observação</label>
          <input class="form-control form-control-sm" type="text" v-model="filters.note" placeholder="Buscar texto na observação..." />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import vSelect from 'vue-select'

export default {
  name: 'TasksMadeFilters',
  components: { DatePicker, vSelect },
  props: ['tasks', 'taskTypes', 'customers'],
  data() {
    return {
      isCollapsed: true,
      filters: {
        startDate: this.formatDateBr(new Date()),
        endDate: this.formatDateBr(new Date()),
        task: null,
        taskType: null,
        customer: null,
        note: ''
      }
    }
  },
  computed: {
    hasActiveFilters() {
      return this.activeFiltersCount > 0
    },
    activeFiltersCount() {
      let count = 0
      if (this.filters.task) count++
      if (this.filters.taskType) count++
      if (this.filters.customer) count++
      if (this.filters.note) count++
      return count
    }
  },
  methods: {
    emit() {
      const payload = { ...this.filters }
      payload.startDate = this.convertBrToIso(payload.startDate)
      payload.endDate = this.convertBrToIso(payload.endDate)
      this.$emit('filter', payload)
    },
    clear() {
      this.filters = {
        startDate: this.formatDateBr(new Date()),
        endDate: this.formatDateBr(new Date()),
        task: null,
        taskType: null,
        customer: null,
        note: ''
      }
      this.$emit('clear')
    },
    formatDateBr(date) {
      const d = new Date(date)
      return `${("0" + d.getDate()).slice(-2)}/${("0" + (d.getMonth() + 1)).slice(-2)}/${d.getFullYear()}`
    },
    convertBrToIso(dateStr) {
      if (!dateStr) return null
      const parts = dateStr.split('/')
      if (parts.length === 3) {
        return `${parts[2]}-${parts[1]}-${parts[0]}`
      }
      return dateStr
    }
  }
}
</script>

<style scoped lang="sass">
.tm-filters-card
  border: none
  border-radius: 16px
  background: rgba(255, 255, 255, 0.8)
  backdrop-filter: blur(10px)
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05)
  margin-bottom: 2rem
  transition: all 0.3s ease
  position: relative

  &.has-filters
    box-shadow: 0 10px 30px rgba(255, 193, 7, 0.15)
    border: 1px solid rgba(255, 193, 7, 0.2)

.cursor-pointer
  cursor: pointer

.icon-box
  width: 38px
  height: 38px
  border-radius: 10px
  display: flex
  align-items: center
  justify-content: center
  transition: all 0.3s ease
  &.bg-primary-soft
    background: rgba(9, 132, 227, 0.1)
  &.bg-secondary-soft
    background: #f1f2f6

.letter-spacing-1
  letter-spacing: 1px

.collapse-icon
  color: #b2bec3
  font-size: 0.8rem

.card-body
  padding: 1.25rem 1.5rem

.filter-label
  display: block
  font-size: 0.65rem
  font-weight: 800
  color: #a4b0be
  text-transform: uppercase
  letter-spacing: 1px
  margin-bottom: 8px
  margin-left: 2px

.v-select
  --vs-border-color: #dfe6e9
  --vs-border-radius: 10px
  --vs-font-size: 0.85rem
  --vs-line-height: 1.2
  background: white
  height: 38px

  ::v-deep .vs__dropdown-toggle
    border-width: 2px
    height: 38px
    padding: 0 8px
    display: flex
    align-items: center

  ::v-deep .vs__selected
    margin: 0
    padding: 0
    line-height: 1.2

  ::v-deep .vs__actions
    padding: 2px 0 0 0

  ::v-deep .vs__search
    margin: 0
    padding: 0

.form-control-sm
  border: 2px solid #dfe6e9
  border-radius: 10px
  padding: 8px 12px
  font-size: 0.85rem
  height: 38px
  background: white
  
  &:focus
    border-color: #00a8ff
    box-shadow: 0 0 0 3px rgba(0, 168, 255, 0.1)

.mx-datepicker
  width: 100% !important
  display: block
  
  ::v-deep .mx-input
    border: 2px solid #dfe6e9
    border-radius: 10px
    height: 38px
    box-shadow: none
    font-size: 0.85rem
    background: white

  ::v-deep .mx-icon-calendar
    top: 50%
    transform: translateY(-50%)
    right: 12px

  ::v-deep .mx-datepicker-popup
    z-index: 9999 !important

.btn-sm
  height: 38px
  width: 38px
  border-radius: 10px
  display: flex
  align-items: center
  justify-content: center
  border: none
  transition: all 0.2s ease

  &.btn-warning
    background: #ffa502
    color: white
    &:hover
      background: #ff7f50
      transform: scale(1.05)

  &.btn-danger
    background: #ff4757
    color: white
    &:hover
      background: #ff6b81
      transform: scale(1.05)
</style>
